"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paginateListEditorDocumentJupyterCellOutputs = void 0;
const Apiv2Client_1 = require("../Apiv2Client");
const ListEditorDocumentJupyterCellOutputsCommand_1 = require("../commands/ListEditorDocumentJupyterCellOutputsCommand");
const core_1 = require("@smithy/core");
exports.paginateListEditorDocumentJupyterCellOutputs = (0, core_1.createPaginator)(Apiv2Client_1.Apiv2Client, ListEditorDocumentJupyterCellOutputsCommand_1.ListEditorDocumentJupyterCellOutputsCommand, "nextToken", "nextToken", "pageSize");
